import type { BoardRecord, SceneData } from "../types";
import { createId } from "./ids";

const SAFE_APP_STATE_KEYS = [
  "viewBackgroundColor",
  "gridSize",
  "gridStep",
  "gridModeEnabled",
  "scrollX",
  "scrollY",
  "zoom",
  "theme",
  "currentItemStrokeColor",
  "currentItemBackgroundColor",
  "currentItemFillStyle",
  "currentItemStrokeWidth",
  "currentItemStrokeStyle",
  "currentItemRoughness",
  "currentItemOpacity",
  "currentItemFontFamily",
  "currentItemFontSize",
  "currentItemTextAlign",
  "currentItemStartArrowhead",
  "currentItemEndArrowhead",
  "currentItemRoundness",
] as const;

export const EMPTY_SCENE: SceneData = {
  elements: [],
  appState: {
    viewBackgroundColor: "#f8fafc",
    gridSize: 24,
    gridStep: 1,
    gridModeEnabled: false,
    scrollX: 0,
    scrollY: 0,
    zoom: { value: 1 },
    theme: "light",
  },
  files: {},
};

function cloneJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}

export function serializeAppState(appState: Record<string, unknown>): Record<string, unknown> {
  const safe: Record<string, unknown> = {};

  for (const key of SAFE_APP_STATE_KEYS) {
    const value = appState[key];
    if (value !== undefined) {
      safe[key] = cloneJson(value);
    }
  }

  return safe;
}

export function createBoard(name = "Papan Tanpa Tajuk", scene: SceneData = EMPTY_SCENE): BoardRecord {
  const now = new Date().toISOString();

  return {
    id: createId("board"),
    version: 1,
    name: name.trim().slice(0, 80) || "Papan Tanpa Tajuk",
    createdAt: now,
    updatedAt: now,
    scene: cloneJson(scene),
  };
}

export function cloneBoard(source: BoardRecord, name = `${source.name} — Salinan`): BoardRecord {
  const clone = createBoard(name, source.scene);
  clone.templateId = source.templateId;
  return clone;
}

export function sceneFromExcalidraw(
  elements: readonly unknown[],
  appState: Record<string, unknown>,
  files: Record<string, unknown>,
): SceneData {
  return {
    elements: cloneJson(elements),
    appState: serializeAppState(appState),
    files: cloneJson(files),
  };
}

